import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import st from "core/shared-translations";
import {
  NavigationRail,
  NavigationRailItem,
  NavigationRailLink
} from "@getgo/chameleon-web-react-wrapper";
import {
  CloudOutlinedIcon,
  PersonCheckmarkActiveIcon,
  PersonCheckmarkInactiveIcon,
  ProtectedFilledIcon,
  ProtectedOutlinedIcon,
  FlowchartOutlinedIcon,
  FlowchartFilledIcon
} from "@getgo/chameleon-icons/react";
import classes from "./main-nav-view.scss";
import environment from "lib/environment";
import { Box } from "@mui/material";

const apiReferenceUrl = environment.get().api_reference_url;

export const SideNav = ({ compareRoutes, movetoDifferentPage, clientIsAdmin }) => {
  const intl = useIntl();
  const navLinks = [
    {
      to: "/clients",
      displayName: intl.formatMessage(st["shared.oauthclients"]),
      activeIcon: <ProtectedFilledIcon />,
      inactiveIcon: <ProtectedOutlinedIcon />,
      display: true,
    },
    {
      to: "/roles",
      displayName: "Role Management",
      activeIcon: <PersonCheckmarkActiveIcon />,
      inactiveIcon: <PersonCheckmarkInactiveIcon />,
      display: clientIsAdmin,
    },
    {
      to: "/scopes",
      displayName: "Scope Management",
      activeIcon: <FlowchartFilledIcon />,
      inactiveIcon: <FlowchartOutlinedIcon />,
      display: clientIsAdmin,
    },

  ];
  return (
    <Box className={classes["sideNavToggle"]}>
      <NavigationRail
        collapse-label="Collapse"
        aria-label="side-nav"
        style={{
          height: "calc(100vh - 46px)",
          zIndex: "2",
          bottom: "0",
          position: "relative",
          display: "inline-flex",
          marginTop: "-3px"
        }}
      >
        <NavigationRailLink
          target="_self"
          key={intl.formatMessage(st["shared.apidocumentation"])}
          href={apiReferenceUrl}
          icon={<CloudOutlinedIcon />}
        >
          {intl.formatMessage(st["shared.apidocumentation"])}
        </NavigationRailLink>
        {navLinks
          .filter(({ display }) => display)
          .map(({ to, displayName, activeIcon, inactiveIcon }) => (
            <NavigationRailItem
              key={displayName}
              selected={compareRoutes(to)}
              icon={compareRoutes(to) ? activeIcon : inactiveIcon}
              onClick={() => movetoDifferentPage(to)}
            >
              {displayName}
            </NavigationRailItem>
          ))}
      </NavigationRail>
    </Box>
  );
};

SideNav.propTypes = {
  compareRoutes: PropTypes.func.isRequired,
  movetoDifferentPage: PropTypes.func.isRequired,
  clientIsAdmin: PropTypes.bool.isRequired,
};


export default SideNav;
